import { Box, Button, Chip, Stack, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import type { KYCFlowState } from '../KYCFlowController';

interface ConditionalScreenProps {
  state: KYCFlowState;
  // Llamado cuando el usuario confirma que leyó el resultado y cierra el widget
  onDismiss?: () => void;
}

// Pantalla de aprobación condicional: KYC aceptado con alerta de revisión manual
export function ConditionalScreen({ state, onDismiss }: ConditionalScreenProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 6,
        gap: 2,
        textAlign: 'center',
      }}
    >
      <WarningAmberIcon sx={{ fontSize: 72, color: 'warning.main' }} />

      <Typography variant="h5" fontWeight={700}>
        Verificación completada con observaciones
      </Typography>

      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 420 }}>
        Tu solicitud será revisada por nuestro equipo de seguridad en las próximas horas.
        Te notificaremos por correo electrónico con el resultado final.
      </Typography>

      {/* Score del comprobante que generó la condición */}
      {state.poaScore && (
        <Stack direction="row" spacing={1} sx={{ mt: 2 }} justifyContent="center">
          {state.idScore && (
            <Chip
              label={`Identificación: ${state.idScore.score}/100`}
              color="success"
              size="small"
              variant="outlined"
            />
          )}
          <Chip
            label={`Comprobante: ${state.poaScore.score}/100`}
            color="warning"
            size="small"
            variant="outlined"
          />
        </Stack>
      )}

      {/* El usuario debe confirmar explícitamente para cerrar el widget */}
      {onDismiss && (
        <Button
          variant="contained"
          color="warning"
          onClick={onDismiss}
          sx={{ mt: 3 }}
        >
          Entendido
        </Button>
      )}
    </Box>
  );
}
